<template>
    <div id="swiper-wrapper">

    <Row class="swiper_row">
        <Col span="0.5">
          <div class="success-left-div" @click="prevBtn">
            <img src="../assets/img/success-left.png" width="50%">
          </div>
        </Col>
        <Col>
          <div>
            <swiper ref="mySwiper" :options="swiperOption">
              <swiper-slide class="recommend-item" v-for="item of recommends" :key="item.goodsId">
                <div class="carousel-content">
                  <div class="content-a">
                      <img :src="item.image" width="40%"/>
                      <h4>{{item.goodsName}}</h4>
                      <p>{{item.goodsContent}}</p>
                      <router-link :to="{path:'successDetails',query:{num:item.goodsId}}">
                        <p class="success-p">MORE>></p>
                      </router-link>
                  </div>
                </div>
              </swiper-slide>

            </swiper>
          </div>
        </Col>
      <Col span="0.5">
          <div class="success-right-div">
            <img src="../assets/img/success-right.png" @click="nextBtn" width="50%">
          </div>
        </Col>
      </Row>

  </div>
</template>

<script>
   import { Icon } from 'vant';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css';
  export default {
    components: {
      [Icon.name]: Icon,
      Swiper,
      SwiperSlide,
    },
    props: {
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 3,
          autoplay: false,
          navigation: {
                   nextEl: '.swiper-button-next',
                   prevEl: '.swiper-button-prev',
                 }
        },
        recommends: [
          {
            goodsId:0,
            image:require("../assets/img/success-dyg.png"),
            goodsName:"东阳光宜都工业园区智慧园区管理平台",
            goodsContent:"以平台建设的模式对园区内外基础数据、业务资源进行整合合同意管理,建立园区数据中心,对园区管理数据进行抽取..."
          },
          {
            goodsId:1,
            image:require("../assets/img/success-jy.png"),
            goodsName:"金鹰重型工程机械股份有限公司综合管理平台",
            goodsContent:"基于IT综合运维管理平台在金鹰重工的部署，及时掌控网络设备、服务器、应用系统及机房的可用性、可靠性和稳定性..."
          },
          {
            goodsId:2,
            image:require("../assets/img/success-yc.png"),
            goodsName:"宜昌山城水都冬虫夏草有限公司IT集成",
            goodsContent:"建设IT集成管理平台搭建各生产相关组件、设备进行数据化模型,同事将辅助应用系统和自动化生产设备统一接入并进行..."
          },
          {
            goodsId:3,
            image:require("../assets/img/R-C.png"),
            goodsName:"中百仓储超市有限公司多媒体发布平台...",
            goodsContent:"以数字化、网络化、智能化的新型播放系统取代现行的广告机本地播放方式，设置网络化的多媒体信息发布系统，方便..."
          }
        ]
      }
    },
    methods:{
      prevBtn() {
        this.$refs.mySwiper.$swiper.slidePrev();
      },
      nextBtn() {
         this.$refs.mySwiper.$swiper.slideNext();
      }
    }
  }
</script>

<style lang="less">
  .ddd{
    width: 40px;
  }
  .ccc{
    width: 40px;
  }
#swiper-wrapper{
  position: relative;
}
  .success-left-div {
    // padding-top: 1rem;
    position: absolute;
    left: 0;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
     z-index: 15;
      cursor: pointer;
  }
  .success-right-div{
    position: absolute;
    right: -18px;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
    z-index: 15;
    cursor: pointer;
    img{
      // margin-left: 100%;
    }
  }
  .carousel-content{
    text-align: center;
    padding: 0 7%;
    .content-a{
 	background-image: linear-gradient(0deg,
		#fdfdfd 50%,
		#f4f5fa 100%);
		height: 3.2rem;
      img{
        margin-top: 0.4rem;
        height: 23.9px;
        margin-bottom: 0.2rem;
      }
      h4{
        	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
	overflow:hidden; //超出的文本隐藏
	text-overflow:ellipsis; //溢出用省略号显示
	white-space:nowrap; //溢出不换行
      }
      p{
        margin-top: 0.2rem;
        padding: 0 0.2rem;
        text-align: left;

        	font-family: SourceHanSansCN-Medium;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
  font-size: 12px;
      }
      .success-p{
		  
        text-align: right;
        color: #5ac1ff;
        cursor: pointer;
      }
    }
  }
  .ivu-tabs-nav-prev{
    top: 12px;
     color: #5ac1ff;
  }
  .ivu-tabs-nav-next{
    top: 12px;
        color: #5ac1ff;
  }
</style>



// WEBPACK FOOTER //
// src/util/SuccessCarousel.vue